(function () {
var root = document.querySelector('.acl');
if (!root) return;
root.addEventListener('click', function (e) {
var dot = e.target.closest('[data-acl-hs]');
var open = root.querySelectorAll('.acl-hs.is-open');
if (dot) {
var hs = dot.parentNode;
var was = hs.classList.contains('is-open');
open.forEach(function (o) { o.classList.remove('is-open'); });
if (!was) hs.classList.add('is-open');
return;
}
if (!e.target.closest('.acl-hs__pop')) open.forEach(function (o) { o.classList.remove('is-open'); });
});
document.addEventListener('keydown', function (e) {
if (e.key === 'Escape') root.querySelectorAll('.acl-hs.is-open').forEach(function (o) { o.classList.remove('is-open'); });
});
root.querySelectorAll('.acl-rail').forEach(function (rail) {
var row = rail.querySelector('.acl-rail__row');
var head = rail.querySelector('.acl-head');
if (!row || !head) return;
var nav = document.createElement('div');
nav.className = 'acl-arrows';
nav.innerHTML = '<button type="button" class="acl-arrow" data-dir="-1" aria-label="Previous products">&larr;</button><button type="button" class="acl-arrow" data-dir="1" aria-label="Next products">&rarr;</button>';
var more = head.querySelector('.acl-more');
var wrap = document.createElement('div');
wrap.className = 'acl-head__end';
if (more) wrap.appendChild(more);
wrap.appendChild(nav);
head.appendChild(wrap);
var btns = nav.querySelectorAll('.acl-arrow');
var update = function () {
var max = row.scrollWidth - row.clientWidth - 2;
nav.style.display = max > 0 ? '' : 'none';
btns[0].disabled = row.scrollLeft <= 2;
btns[1].disabled = row.scrollLeft >= max;
};
nav.addEventListener('click', function (e) {
var b = e.target.closest('.acl-arrow');
if (!b) return;
var card = row.firstElementChild;
var step = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(row).columnGap || 0) : row.clientWidth;
row.scrollBy({ left: step * parseInt(b.getAttribute('data-dir'), 10), behavior: 'smooth' });
});
row.addEventListener('scroll', update, { passive: true });
window.addEventListener('resize', update);
update();
});
var count = parseInt(root.getAttribute('data-acl-leaves'), 10) || 0;
var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
if (count && !still) {
if (window.innerWidth < 750) count = Math.ceil(count * 0.6);
var shapes = [
'<svg viewBox="0 0 24 24"><path fill="C" d="M12 1.5l1.7 4.6 3.6-2-.9 4.6 4.6.6-3.4 3 2.2 3.8-4.4-.8-.7 4.7L12 17l-2.7 2.9-.7-4.7-4.4.8 2.2-3.8-3.4-3 4.6-.6-.9-4.6 3.6 2z"/><path d="M12 22.5V9" stroke="rgba(60,25,8,.35)" stroke-width=".8" fill="none"/></svg>',
'<svg viewBox="0 0 24 24"><path fill="C" d="M12 1.8C5.2 6.4 4.1 14.6 12 22.2c7.9-7.6 6.8-15.8 0-20.4z"/><path d="M12 22V5M12 11l-3.2-2.6M12 15l3.4-2.8M12 18l-2.6-2" stroke="rgba(60,25,8,.3)" stroke-width=".8" fill="none"/></svg>',
'<svg viewBox="0 0 24 24"><path fill="C" d="M12 2.5c-1.6 1.7-3.8 1-4.6 3.2-1.2-.6-3.2.3-2.6 2.6-1.6.6-2 2.8-.5 4 .1 1.7 1.8 2.8 3.3 2.3.6 1.7 2.7 2.3 3.9 1.3V22h1v-6.1c1.2 1 3.3.4 3.9-1.3 1.5.5 3.2-.6 3.3-2.3 1.5-1.2 1.1-3.4-.5-4 .6-2.3-1.4-3.2-2.6-2.6-.8-2.2-3-1.5-4.6-3.2z"/></svg>'
];
var colours = ['#b5562a', '#cf8a36', '#8f3d1f', '#c9a24a', '#a8461f', '#d9a35b', '#7c5a2c'];
var layer = document.createElement('div');
layer.className = 'acl-leaves';
layer.setAttribute('aria-hidden', 'true');
var r = function (a, b) { return a + Math.random() * (b - a); };
for (var i = 0; i < count; i++) {
var leaf = document.createElement('span');
leaf.className = 'acl-leaf';
var d = r(11, 20);
leaf.style.cssText = '--x:' + r(-5, 100).toFixed(1) + 'vw;--s:' + r(16, 32).toFixed(0) + 'px;--d:' + d.toFixed(1) + 's;--dl:' + (-r(0, d)).toFixed(1) + 's;--dx:' + r(-18, 22).toFixed(0) + 'vw;--o:' + r(.7, .95).toFixed(2) + ';--sw:' + r(2.2, 4.2).toFixed(1) + 's;--sp:' + r(5, 11).toFixed(1) + 's';
leaf.innerHTML = '<i>' + shapes[i % shapes.length].replace(/fill="C"/, 'fill="' + colours[Math.floor(Math.random() * colours.length)] + '"') + '</i>';
layer.appendChild(leaf);
}
root.appendChild(layer);
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (en) { layer.classList.toggle('is-off', !en[0].isIntersecting); }).observe(root);
}
}
var sticky = root.querySelector('[data-acl-sticky]');
var hero = root.querySelector('.acl-hero');
var shop = root.querySelector('#acl-shop');
if (sticky) {
var onScroll = function () {
var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 400;
var inShop = false;
if (shop) { var rc = shop.getBoundingClientRect(); inShop = rc.top < window.innerHeight * 0.8 && rc.bottom > 0; }
sticky.classList.toggle('is-on', past && !inShop);
};
window.addEventListener('scroll', onScroll, { passive: true });
onScroll();
}
})();